<template>
  <el-dialog
    title="反馈提交"
    :visible.sync="visible"
    width="640px"
    top="6vh"
    :close-on-click-modal="false"
    custom-class="feedback-submit-dialog"
    @closed="onClosed"
  >
    <div class="feedback-form">
      <div class="feedback-section">
        <div class="feedback-section__label">反馈类型</div>
        <el-select v-model="form.feedback_type" placeholder="选择反馈类型" style="width: 100%">
          <el-option label="软件缺陷反馈" :value="1"></el-option>
          <el-option label="新功能建议" :value="2"></el-option>
        </el-select>
      </div>

      <div class="feedback-section" v-if="form.feedback_type === 1">
        <div class="feedback-section__label">相关店铺</div>
        <el-select
          v-model="form.shop_id"
          filterable
          clearable
          placeholder="请选择店铺"
          style="width: 100%"
          :loading="shopLoading"
        >
          <el-option
            v-for="shop in shopList"
            :key="shop.id"
            :label="shop.shop_name || shop.name || String(shop.id)"
            :value="shop.id"
          ></el-option>
        </el-select>
      </div>

      <div class="feedback-section">
        <div class="feedback-section__label">
          {{ form.feedback_type === 2 ? "建议描述" : "问题描述" }}
        </div>
        <el-input
          type="textarea"
          :rows="5"
          maxlength="5000"
          show-word-limit
          v-model="form.content"
          :placeholder="
            form.feedback_type === 2
              ? '请针对您希望增加的功能进行填充'
              : '请针对您遇到的问题进行填充'
          "
        ></el-input>
      </div>

      <div class="feedback-section">
        <div class="feedback-section__label">
          问题链接提供
          <span class="feedback-section__hint">请参照此格式进行填充</span>
          <el-tooltip content="可填写商品链接、后台页面链接等，便于我们定位问题" placement="top">
            <i class="el-icon-question feedback-section__help"></i>
          </el-tooltip>
        </div>
        <div class="feedback-link-tabs">
          <button
            v-for="i in 3"
            :key="i"
            type="button"
            class="feedback-link-tab"
            :class="{ 'is-active': activeLink === i }"
            @click="activeLink = i"
          >
            链接{{ i }}
          </button>
        </div>
        <el-input
          type="textarea"
          :rows="3"
          v-model="form['link' + activeLink]"
          placeholder="请参照上述格式进行填充"
        ></el-input>
      </div>

      <div class="feedback-section">
        <div class="feedback-section__label">截图提供</div>
        <div class="feedback-images">
          <div class="feedback-image-slot" v-for="(img, idx) in images" :key="idx">
            <div class="feedback-image-box" @click="triggerPick(idx)">
              <img v-if="img" :src="img" class="feedback-image-preview" />
              <div v-else class="feedback-image-empty">
                <i class="el-icon-plus"></i>
                <span>等待选择</span>
              </div>
              <div v-if="uploadingIndex === idx" class="feedback-image-mask">上传中...</div>
            </div>
            <div class="feedback-image-actions">
              <i class="el-icon-folder-opened" title="选择图片" @click="triggerPick(idx)"></i>
              <i class="el-icon-delete" title="清除" @click="clearImage(idx)"></i>
            </div>
          </div>
        </div>
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          style="display: none"
          @change="onFileChange"
        />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { fetchDouDianAccounts } from "@/script/doudianLocalLogin";

export default {
  name: "FeedbackSubmitDialog",
  data() {
    return {
      visible: false,
      submitting: false,
      shopLoading: false,
      shopList: [],
      activeLink: 1,
      pickIndex: 0,
      uploadingIndex: -1,
      images: [null, null, null],
      form: {
        feedback_type: null,
        shop_id: null,
        content: "",
        link1: "",
        link2: "",
        link3: "",
      },
    };
  },
  methods: {
    open() {
      this.resetForm();
      this.visible = true;
      this.loadShops();
    },
    resetForm() {
      this.form = {
        feedback_type: null,
        shop_id: null,
        content: "",
        link1: "",
        link2: "",
        link3: "",
      };
      this.images = [null, null, null];
      this.activeLink = 1;
      this.uploadingIndex = -1;
      this.submitting = false;
    },
    onClosed() {
      this.resetForm();
    },
    async loadShops() {
      this.shopLoading = true;
      try {
        const res = await fetchDouDianAccounts(
          (url, data) => this.$api.post(url, data),
          { requireLogin: false, status: 1, pageSize: 1000 }
        );
        if (res && res.code == 1) {
          this.shopList = res.list || [];
        } else {
          this.shopList = [];
        }
      } catch (e) {
        this.shopList = [];
      } finally {
        this.shopLoading = false;
      }
    },
    triggerPick(idx) {
      this.pickIndex = idx;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
        this.$refs.fileInput.click();
      }
    },
    clearImage(idx) {
      this.$set(this.images, idx, null);
    },
    async onFileChange(e) {
      const file = e.target && e.target.files && e.target.files[0];
      if (!file) return;
      if (!/^image\//.test(file.type)) {
        this.$message.warning("请选择图片文件");
        return;
      }
      const idx = this.pickIndex;
      this.uploadingIndex = idx;
      try {
        const formData = new FormData();
        formData.append("file", file);
        const res = await this.$api.post(
          "/admintooltaobaoaccount/uploadimage",
          formData,
          { "Content-Type": "multipart/form-data" }
        );
        if (res && res.code == 1 && res.url) {
          this.$set(this.images, idx, res.url);
          this.$message.success("上传成功");
        } else {
          this.$message.error((res && res.msg) || "上传失败");
        }
      } catch (err) {
        this.$message.error("上传失败");
      } finally {
        this.uploadingIndex = -1;
      }
    },
    async submit() {
      if (!this.form.feedback_type) {
        this.$message.warning("请选择反馈类型");
        return;
      }
      if (this.form.feedback_type === 1 && !this.form.shop_id) {
        this.$message.warning("请选择相关店铺");
        return;
      }
      const content = (this.form.content || "").trim();
      if (!content) {
        this.$message.warning("请填写描述内容");
        return;
      }
      let shopName = "";
      if (this.form.feedback_type === 1 && this.form.shop_id) {
        const shop = this.shopList.find((s) => s.id == this.form.shop_id);
        shopName = (shop && (shop.shop_name || shop.name)) || "";
      }
      const imageUrls = this.images.filter((u) => !!u);
      this.submitting = true;
      try {
        const res = await this.$api.post("/admintooluserfeedback/submit", {
          feedback_type: this.form.feedback_type,
          shop_id: this.form.feedback_type === 1 ? this.form.shop_id : 0,
          shop_name: shopName,
          content,
          link1: (this.form.link1 || "").trim(),
          link2: (this.form.link2 || "").trim(),
          link3: (this.form.link3 || "").trim(),
          images: JSON.stringify(imageUrls),
        });
        if (res && res.code == 1) {
          this.$message.success("提交成功，感谢您的反馈");
          this.visible = false;
        } else {
          this.$message.error((res && res.msg) || "提交失败");
        }
      } catch (e) {
        this.$message.error("提交失败");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.feedback-form {
  max-height: 68vh;
  overflow-y: auto;
  padding-right: 4px;
}
.feedback-section {
  margin-bottom: 18px;
}
.feedback-section__label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}
.feedback-section__label::before {
  content: "";
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #409eff;
  border-radius: 1px;
  margin-right: 8px;
}
.feedback-section__hint {
  margin-left: 8px;
  color: #f56c6c;
  font-size: 12px;
  font-weight: 400;
}
.feedback-section__help {
  margin-left: 4px;
  color: #f56c6c;
  cursor: help;
}
.feedback-link-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
.feedback-link-tab {
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  border-radius: 4px;
  padding: 4px 14px;
  font-size: 13px;
  cursor: pointer;
  outline: none;
}
.feedback-link-tab.is-active {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}
.feedback-images {
  display: flex;
  gap: 16px;
}
.feedback-image-slot {
  width: 120px;
}
.feedback-image-box {
  position: relative;
  width: 120px;
  height: 120px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #fafafa;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feedback-image-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #909399;
  font-size: 12px;
  gap: 6px;
}
.feedback-image-empty i {
  font-size: 22px;
}
.feedback-image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.feedback-image-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.feedback-image-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 6px;
  color: #909399;
}
.feedback-image-actions i {
  cursor: pointer;
  font-size: 14px;
}
.feedback-image-actions i:hover {
  color: #409eff;
}
.feedback-image-actions .el-icon-delete:hover {
  color: #f56c6c;
}
</style>
